export default __webpack_public_path__ + "static/image02-f0473d9e2fd94522a5e4afa573c0beb7.webp";